import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	OnChanges
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ProtocolSettings, ProtocolSettingsTypes, PrtgSettings } from 'DiscoveryEngine.TS/Protocols';
import { Guid, StringUtils } from "DiscoveryEngine.TS/Utils";
import { ComponentBase, Changeable } from "common";
import { NavigationService } from 'netview';
import { DiscResultsService } from 'discovery';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { IdentityService, LicensingService } from 'identity';
import { MessageService } from 'base';
import { ToolsService } from 'tools';
import { ITGlueExport } from 'DiscoveryEngine.TS/Export';
import { ConfigurationService } from '../../../configuration';
import { AgentDto } from '../../../UvExplorerServer.Dtos.TS/Agents';
import { ScheduledDiscovery } from '../../../DiscoveryEngine.TS/Discovery';


@Component({
	selector: 'itglue-export-config',
	templateUrl: '../itglue-export-config/itglue-export-config.component.html',
	styleUrls: ['../itglue-export-config/itglue-export-config.component.scss']
})
export class ITGlueExportConfigComponent extends ComponentBase implements OnDestroy, OnChanges, Changeable {

	@Input()
	public Network: NetViewDto;

	@Input()
	public Export: ITGlueExport;

	@Input()
	public Agent: AgentDto;

	@Input()
	public ScheduledDiscovery: ScheduledDiscovery;

	@Input()
	public EnableExportOrigin: boolean;

	public SettingsForm: UntypedFormGroup;

	public EnableExport: UntypedFormControl;

	public TargetServerApiURL: UntypedFormControl;
	public TargetServerApiKey: UntypedFormControl;
	public Organization: UntypedFormControl;
	public Location: UntypedFormControl;

	public ExportOrigin: UntypedFormControl;

	public ExportDevices: UntypedFormControl;
	public ExportDeviceInterfaces: UntypedFormControl;
	public ExportConfigs: UntypedFormControl;
	public ExportPasswords: UntypedFormControl;
	public ExportMapToLocation: UntypedFormControl;

	public MapFileName: UntypedFormControl;
	public MapFileExtension: UntypedFormControl;

	public exportDevicesChecked: boolean;
	public exportDeviceInterfacesChecked: boolean;

	private apiKeyChanged: boolean;
	private apiKeyChangedSub: Subscription;

	public mapDropdownOptions: string[];

	constructor(private fb: UntypedFormBuilder,
		private navService: NavigationService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private messageService: MessageService,
		private configService: ConfigurationService,
		private toolsService: ToolsService) {

		super();

		this.Network = null;
		this.Export = null;
		this.EnableExportOrigin = false;

		this.mapDropdownOptions = ITGlueExport.mapFormatDropdownOptions;
	}

	public ngOnDestroy(): void {
		if (this.apiKeyChangedSub) {
			this.apiKeyChangedSub.unsubscribe();
		}
	}

	public get isLicenseValid(): boolean {
		//return this.licensingService.isLicenseValid;
		return true;
	}

	protected BuildForm(): void {

		let enableExport = false;

		// ITGlue settings
		let serverApiURL = "";
		let serverApiKey = "";
		let organization = "";
		let location = "";

		let exportOrigin = "";

		let exportDevices = false;
		let exportDeviceInterfaces = false;
		let exportConfigs = false;
		let exportPassswords = false;
		let exportMapToLocation = false;
		let mapFilename = "";
		let mapFileExt = "";

		if (this.Export) {
			let value = this.Export;

			enableExport = value.EnableExport;

			if (value.HasTargetServerApiURL)
				serverApiURL = value.TargetServerApiURL;
			if (value.HasTargetServerApiKey)
				serverApiKey = (this.hidePassword(value.TargetServerApiKey));
			if (value.HasOrganization)
				organization = value.Organization;
			if (value.HasLocation)
				location = value.Location;

			if (value.HasExportOrigin)
				exportOrigin = value.ExportOrigin;

			exportDevices = value.ExportDevices;
			exportDeviceInterfaces = value.ExportDeviceInterfaces;
			exportConfigs = value.ExportConfigs;
			exportPassswords = value.ExportPasswords;
			exportMapToLocation = value.ExportMapToLocation;
			mapFilename = value.MapFilename;
			mapFileExt = value.MapFileExtension;
		}

		this.EnableExport = new UntypedFormControl(enableExport);

		this.TargetServerApiURL = new UntypedFormControl(serverApiURL);
		this.TargetServerApiKey = new UntypedFormControl(serverApiKey);
		this.Organization = new UntypedFormControl(organization);
		this.Location = new UntypedFormControl(location);

		this.ExportOrigin = new UntypedFormControl(exportOrigin);

		this.ExportDevices = new UntypedFormControl(exportDevices);
		this.ExportDeviceInterfaces = new UntypedFormControl(exportDeviceInterfaces);
		this.ExportConfigs = new UntypedFormControl(exportConfigs);
		this.ExportPasswords = new UntypedFormControl(exportPassswords);
		this.ExportMapToLocation = new UntypedFormControl(exportMapToLocation);

		this.MapFileName = new UntypedFormControl(mapFilename);
		this.MapFileExtension = new UntypedFormControl(mapFileExt);

		this.apiKeyChanged = false;
		this.apiKeyChangedSub = this.TargetServerApiKey.valueChanges.subscribe(() => {
			this.apiKeyChanged = true;
		});

		this.SettingsForm = this.fb.group({
			EnableExport: this.EnableExport,
			TargetServerApiURL: this.TargetServerApiURL,
			TargetServerApiKey: this.TargetServerApiKey,
			Organization: this.Organization,
			Location: this.Location,
			ExportOrigin: this.ExportOrigin,
			ExportDevices: this.ExportDevices,
			ExportDeviceInterfaces: this.ExportDeviceInterfaces,
			ExportConfigs: this.ExportConfigs,
			ExportPasswords: this.ExportPasswords,
			ExportMapToLocation: this.ExportMapToLocation,
			MapFileName: this.MapFileName,
			MapFileExtension: this.MapFileExtension,

		},
		{
			validator: Validators.compose([
				this.validITGlueSettings(this.EnableExport, this.TargetServerApiURL, this.TargetServerApiKey, this.Organization)

				// Group Name is now optional
				//this.validGroupName(this.EnableExport, this.GroupName)
			])
		});
	}

	public get ExportEnabled(): boolean {
		if (this.EnableExport) {
			return this.EnableExport.value;
		}
		else {
			return false;
		}
	}

	public get ExportDevicesEnabled(): boolean {
		if (this.ExportDevices) {
			return this.ExportDevices.value;
		}
		else {
			return false;
		}
	}

	public exportDevicesCheckboxChanged(checked: boolean) {
		this.exportDevicesChecked = checked;
		if (!checked) {
			this.ExportDeviceInterfaces.setValue(false);
			//this.ExportDeviceInterfaces.disable();
		} else {
			//this.ExportDeviceInterfaces.enable();
		}
	}

	//public getIntegrationSettings(): Integration {
	//	const outputIntegration = new Integration(IntegrationNames.ITGlue);
	//	outputIntegration.Enabled = this.enabled.value;
	//	outputIntegration.ServerURL = this.serverURL.value;
	//	outputIntegration.ApiServerURL = this.apiServerURL.value;
	//	if (this.apiKeyChanged) {
	//		outputIntegration.ApiKey = StringUtils.ObfuscateString2(this.apiKey.value);
	//	}
	//	else {
	//		outputIntegration.ApiKey = this.inputSettings.ApiKey;
	//	}

	//	return outputIntegration;
	//}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public get tempChanges(): boolean {
		return this.SettingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.SettingsForm.valid;
	}

	public discardTempChanges(): void {
		this.BuildForm();
	}

	public applyTempChanges(): void {
		if (this.Export) {
			let value = this.Export;

			value.EnableExport = this.EnableExport.value;

			value.TargetServerApiURL = this.TargetServerApiURL.value;
			if (this.apiKeyChanged) {
				value.TargetServerApiKey = StringUtils.ObfuscateString2(this.TargetServerApiKey.value);
			}
			value.Organization = this.Organization.value;
			value.Location = this.Location.value;

			value.ExportOrigin = this.ExportOrigin.value;

			value.ExportDevices = this.ExportDevices.value;
			value.ExportDeviceInterfaces = this.ExportDeviceInterfaces.value;
			value.ExportConfigs = this.ExportConfigs.value;
			value.ExportPasswords = this.ExportPasswords.value;
			value.ExportMapToLocation = this.ExportMapToLocation.value;

			value.MapFilename = this.MapFileName.value;
			value.MapFileExtension = this.MapFileExtension.value;
			
			this.BuildForm();
		}
	}

	public onPasswordKeyDownHandler(event: any): void {
		if (!this.apiKeyChanged) {
			this.apiKeyChanged = true;

			this.TargetServerApiKey.setValue('');
			this.TargetServerApiKey.markAsDirty();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["ITGlue Export"];
	}

	private validITGlueSettings(enableExport: UntypedFormControl, serverApiURL: UntypedFormControl, serverApiKey: UntypedFormControl, organization: UntypedFormControl): ValidatorFn {
		return () => {
			if (enableExport.value) {
				if (!serverApiURL.value) {
					return {
						validITGlueSettings: { valid: false }
					};
				}
				else if (!serverApiKey.value) {
					return {
						validITGlueSettings: { valid: false }
					};
				}
				else if (!organization.value) {
					return {
						validITGlueSettings: { valid: false }
					};
				}
				else {
					return null;
				}
			}
		}
	}


	private validOrganization(enableExport: UntypedFormControl, organization: UntypedFormControl): ValidatorFn {
		return () => {
			if (enableExport.value) {
				if (!organization.value) {
					return {
						validOrganization: { valid: false }
					};
				}
				else {
					return null;
				}
			}
		}
	}

	public ExportNow(): void {
		if (this.tempChanges) {
			this.messageService.displayInfoMessage(
				"You have unsaved changes to your ITGlue export settings.\nPlease save before exporting.", 10000);
		}
		else {
			if (!!this.Network && !!this.Network.Guid) {
				let sessionGuid = this.identityService.sessionGuid;
				let netViewGuid = this.Network.Guid;
				let agentGuid = this.navService.location.agentGuid;
				let schedDiscGuid = this.navService.location.schedDiscGuid;
				this.discResultsService.runITGlueExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid).subscribe(
					(result: boolean) => {
						this.messageService.displayInfoMessage("ITGlue Export has been initiated");
					},
					(error) => {
						this.messageService.displayErrorMessage("ITGlue Export failed");
					});
			}
		}
	}

	public get enableTestITGlueButton(): boolean {
		return (!!this.TargetServerApiURL && !!this.TargetServerApiURL.value
			&& !!this.TargetServerApiKey && !!this.TargetServerApiKey.value);
	}

	public testITGlueConnect(): void {
		let apiKey = "";
		if (this.apiKeyChanged) {
			apiKey = StringUtils.ObfuscateString2(this.TargetServerApiKey.value);
		}
		else {
			apiKey = this.Export.TargetServerApiKey;
		}
		this.configService.testITGlueConnection(this.TargetServerApiURL.value, apiKey).subscribe(
			() => {
				this.messageService.displayInfoMessage("Successfully connected to ITGlue");
			},
			(error) => {
				this.messageService.displayErrorMessage("Failed to connect to ITGlue");
			});
	}
}
